import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import MainFooter from '../../components/layout/MainFooter';

const Sitemap = () => {
  const { user, userProfile } = useAuth();
  const isVA = userProfile?.role === 'va';
  const isEmployer = userProfile?.role === 'employer';
  const isAdmin = userProfile?.role === 'admin';

  const publicPages = [
    { path: '/', label: 'Home' },
    { path: '/how-it-works', label: 'How It Works' },
    { path: '/skills-directory', label: 'Skills Directory' },
    { path: '/browse-candidates', label: 'Browse Virtual Assistants' },
    { path: '/pricing', label: 'Pricing Plans' },
  ];

  const legalPages = [
    { path: '/community-guidelines', label: 'Community Guidelines' },
    { path: '/privacy-policy', label: 'Privacy Policy' },
    { path: '/terms-of-service', label: 'Terms of Service' },
  ];

  const authPages = [
    { path: '/login-register', label: 'Login / Register' },
    { path: '/auth/reset-password', label: 'Reset Password' },
  ];

  const vaPages = [
    { path: '/va-dashboard', label: 'VA Dashboard' },
    { path: '/va-profile', label: 'My Profile' },
    { path: '/va-profile-settings', label: 'Profile Settings' },
    { path: '/va-portfolio-management', label: 'Portfolio Management' },
    { path: '/job-search', label: 'Job Search' },
    { path: '/applications', label: 'My Applications' },
    { path: '/saved-jobs', label: 'Saved Jobs' },
    { path: '/my-contracts', label: 'My Contracts & Timesheet' },
    { path: '/activities', label: 'Recent Activities' },
    { path: '/skills-assessment', label: 'Skills Assessment' },
    { path: '/up-skills', label: 'Skill Development' },
  ];

  const employerPages = [
    { path: '/employer-dashboard', label: 'Employer Dashboard' },
    { path: '/employer-profile-settings', label: 'Employer Profile Settings' },
    { path: '/job-posting', label: 'Post a Job' },
    { path: '/candidate-search', label: 'Search Candidates' },
    { path: '/auto-matching', label: 'AI Candidate Matching' },
    { path: '/interview-management', label: 'Interview Management' },
    { path: '/team-management', label: 'Team Management' },
    { path: '/advanced-analytics', label: 'Analytics Dashboard' },
    { path: '/enterprise-features', label: 'Enterprise Features' },
  ];

  const adminPages = [
    { path: '/admin-moderation', label: 'Moderation Dashboard' },
    { path: '/admin/help-cms', label: 'Help Articles CMS' },
    { path: '/admin/support', label: 'Support Dashboard' },
    { path: '/admin/feedback', label: 'Feedback Dashboard' },
    { path: '/admin-profile-settings', label: 'Admin Settings' },
  ];

  const sharedPages = [
    { path: '/notifications', label: 'Notifications' },
    { path: '/help-support', label: 'Help & Support' },
  ];

  const SitemapSection = ({ title, pages, icon }) => (
    <div className="mb-8">
      <h2 className="text-xl font-semibold text-gray-900 mb-4 flex items-center">
        {icon && <span className="mr-2">{icon}</span>}
        {title}
      </h2>
      <ul className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
        {pages.map((page) => (
          <li key={page.path}>
            <Link
              to={page.path}
              className="text-blue-600 hover:text-blue-800 hover:underline transition-colors"
            >
              {page.label}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );

  return (
    <div className="min-h-screen bg-gray-50 ">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="bg-white rounded-lg shadow-sm p-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">Sitemap</h1>
          <p className="text-gray-600 mb-8">
            Find your way around VA Sprouts. Browse all available pages and features.
          </p>

          <SitemapSection title="Public Pages" pages={publicPages} icon="🌐" />
          
          {!user && <SitemapSection title="Authentication" pages={authPages} icon="🔐" />}
          
          {(isVA || !user) && (
            <SitemapSection 
              title="Virtual Assistant Area" 
              pages={vaPages} 
              icon="👤"
            />
          )}
          
          {(isEmployer || !user) && (
            <SitemapSection 
              title="Employer Area" 
              pages={employerPages} 
              icon="💼"
            />
          )}
          
          {(isAdmin || !user) && (
            <SitemapSection 
              title="Admin Area" 
              pages={adminPages} 
              icon="⚙️"
            />
          )}
          
          {user && <SitemapSection title="Communication & Support" pages={sharedPages} icon="💬" />}
          
          <SitemapSection title="Legal & Policies" pages={legalPages} icon="📄" />

          <div className="mt-12 pt-8 border-t border-gray-200">
            <p className="text-sm text-gray-600">
              Can't find what you're looking for? Visit our{' '}
              <Link to="/help-support" className="text-blue-600 hover:underline">
                Help & Support
              </Link>{' '}
              page or contact us directly.
            </p>
          </div>
        </div>
       
      </div>
       <MainFooter />
    </div>
  );
};

export default Sitemap;
